import React, { useEffect, useState } from "react";
import { HiOutlineTicket } from "react-icons/hi";
import { Assort } from "../../../models/Assort";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";
import { BiInfoCircle } from "react-icons/bi";
import HtmlTooltip from "@mui/material/Tooltip";
import { TicketAccess } from "../../../models/TicketAccess";
import "../../../../style/buttons.scss";
import getId from "../../../../utils/getId";
import { BasketItem } from "../../../models/BasketItem";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import ModalComponent from "../../../../features/ModalComponent";
import { useTranslation } from "react-i18next";
import { QntStateItem } from "../../../models/QntStateItem";
import EAButton from "../../shared/Buttons/EAButton";
import { BsBasket3 } from "react-icons/bs";
import PassModal from "../../Passes/SinglePass/PassModal";
import usePasses from "../../Passes/hooks/usePasses";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { State } from "../../../store";
import { FINALIZE_PAGE } from "../../../routes";

interface IProps {
  ticketLimit?: number;
  item: Assort;
  exercise?: TicketAccess;
  preBasket: BasketItem[];
  addItemToBasket: (assort: Assort, exercise?: TicketAccess) => void;
  removeItemFromBasket: (assort: Assort, exercise?: TicketAccess) => void;
  qntState?: QntStateItem[];
} // optional for styling

const PassLineSummary: React.FC<IProps> = ({
  item,
  exercise,
  preBasket,
  ticketLimit,
  addItemToBasket,
  removeItemFromBasket,
  qntState,
}: IProps) => {
  const { t } = useTranslation();

  const getQnt = (value: Assort): number => {
    if (qntState && qntState.length > 0 && exercise) {
      const foundQnt = qntState.find(
        (item) => item.assortIds === getId(value) && item.exerciseIds === exercise.exerciseIds
      );
      return foundQnt ? foundQnt.count : 0;
    } else {
      const itemBasket = preBasket.find((item) => item.assortIds === getId(value));
      return itemBasket ? itemBasket.qnt : 0;
    }
  };

  useEffect(() => {
    if (item.maxSale === 0 || !item.maxSale) {
      setMaxQnt(99);
    } else {
      setMaxQnt(item.maxSale);
    }
    //eslint-disable-next-line
  }, []);
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const [, setMaxQnt] = useState(0);
  const isDiscount = item.price !== item.listPrice;
  const [openPass, setOpenPass] = useState(false);
  const { selectedDate, setDateBetween } = usePasses();
  const { handleAddBasketLimited } = useBasketManager();
  const { scrollToTop } = useParentMessage();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpenPass(false);
    // onModalClose?.();
  };

  const itemName = item.displayWebName || item.name;

  return (
    <>
      <div
        className={
          getQnt(item) > 0
            ? "ticket-line-summary ticket-line-active ticket-line flex-between-center"
            : "ticket-line-summary ticket-line flex-between-center"
        }
      >
        <div className="ticket-line-left flex-start-center">
          <div className="ticket-line-name-container">
            <HiOutlineTicket className="ticket-line-icon" />
            <HtmlTooltip placement="top" arrow={true} title={itemName}>
              <b className="ticket-line-name">{itemName}</b>
            </HtmlTooltip>
          </div>

          <>
            {item.description.length > 2 && (
              <>
                {isDesktop ? (
                  <HtmlTooltip
                    placement="right"
                    arrow={true}
                    title={
                      <>
                        <article
                          className="tooltip-description"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></article>
                      </>
                    }
                  >
                    <b>
                      <BiInfoCircle className="tooltip-icon" />
                    </b>
                  </HtmlTooltip>
                ) : (
                  <b onClick={() => setOpen(!open)}>
                    <BiInfoCircle className="tooltip-icon" />
                  </b>
                )}
              </>
            )}
          </>
        </div>

        <div className="ticket-line-right flex-end-center">
          <div className="price-container">
            <b className={`price ${isDiscount ? "price-through" : ""}`}>
              {item.listPrice.toFixed(2)} {t("zl")}
            </b>
            {isDiscount && (
              <b className={`price ${isDiscount ? "price-through-color" : ""}`}>
                {item.price.toFixed(2)} {t("zl")}
              </b>
            )}
          </div>

          <div className="qnt flex-end-center">
            <EAButton
              title={isDesktop ? t("wybierz") : t("wybierz")}
              endIcon={<BsBasket3 />}
              onClick={() => {
                setOpenPass(true);
              }}
            />
          </div>
        </div>
      </div>

      {open && (
        <div className="schedule-modal-info">
          <ModalComponent
            footer={false}
            open={open}
            closeModal={() => setOpen(false)}
            title={item.name}
            onAccept={() => setOpen(false)}
            acceptText={t("przeczytalem")}
          >
            {item.description.length > 1 ? (
              <p className="news-modal-body" dangerouslySetInnerHTML={{ __html: item.description }}></p>
            ) : (
              <p className="news-modal-body">{t("brak_opisu")}</p>
            )}
          </ModalComponent>
        </div>
      )}

      <PassModal
        isOpen={openPass}
        onClose={handleClose}
        pass={item}
        selectedDate={selectedDate}
        setDateBetween={setDateBetween}
        onAddToBasket={() => {
          handleAddBasketLimited(item, 1, selectedDate);
          handleClose();
          scrollToTop();
          if (saleConfiguration.popupAfterAddTicket === false) {
            setTimeout(() => {
              navigate(FINALIZE_PAGE);
            }, 100);
          }
        }}
      />
    </>
  );

};

export default PassLineSummary;
